exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.login-dropdown_login_2HoP0 {\n    padding: .625rem;\n}\n", ""]);

// exports
exports.locals = {
	"login": "login-dropdown_login_2HoP0"
};